// hook/useGeneralUrl.ts
import { useMemo } from 'react';
import { buildUrl } from './urlUtils';
import { BasicTab } from '../config/type';
import { FormFilter } from '../components/Filters';

export function useGeneralUrl(
  basicTab: BasicTab,
  selectedRDV: string | number | '',
  filters?: FormFilter,
  orderGroup?: string | ''
) {
  return useMemo(
    () => buildUrl(basicTab, selectedRDV, filters, orderGroup),
    [basicTab, selectedRDV, filters, orderGroup]
  );
}


export function useExportUrl(
  basicTab: BasicTab,
  selectedRDV: string | number | '',
  format: 'csv' | 'pdf',
  filters?: FormFilter,
  orderGroup?: string | ''
) {
  return useMemo(() => {
    const base = buildUrl(basicTab, selectedRDV, filters, orderGroup);
    if (!base) return undefined;
    // Se il backend accetta lo stesso endpoint:
    return `${base}&download=${format}`;

    // In alternativa, se hai un endpoint dedicato:
    // return base.replace(`/tables/`, `/tables/export/`) + `&download=${format}`;
  }, [basicTab, selectedRDV, format, filters, orderGroup]);
}
